import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '../Filters.style';
import { PartnerDealerOption } from '../../../types';
import CheckboxSelector from '../../CheckboxComponent';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import {
  PartnerDealerWrapper,
  FilterTypeName,
  ListOfDealers,
} from './PartnerDealerListSelector.styles';

interface PartnerDealersListSelectorType {
  filterType: string;
  filterOptions: PartnerDealerOption[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const PartnerDealersListSelector: React.FC<PartnerDealersListSelectorType> = ({
  filterType,
  filterOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const { t } = useTranslation();
  const selectedPartnerDealers = useMemo(() => {
    return confirmedFilters.partnerDealers;
  }, [confirmedFilters.partnerDealers]);

  const inSelectedList = (option: string) => {
    return selectedPartnerDealers?.some((value: any) => value === option);
  };

  return (
    <Filter>
      <PartnerDealerWrapper>
        <FilterTypeName>{t(`vlp.filters.filterTitle.partnerDealers`)}:</FilterTypeName>
        <ListOfDealers data-testid="partner-deales-list">
          {Object.keys(filterOptions).map((filterOption, index) => {
            const option = filterOptions[index];
            return (
              <CheckboxSelector
                text={option?.dealerName}
                key={option?.dealerId}
                value={option?.dealerId}
                filterType="partnerDealers"
                onChange={() => {
                  return handleAddFilter(filterType, option.dealerId);
                }}
                inputName={`${option?.dealerName}-${index}`}
                disabled={option.isMainDealer}
                checked={option.isMainDealer || inSelectedList(option.dealerId)}
                isPartnerDealer
              />
            );
          })}
        </ListOfDealers>
      </PartnerDealerWrapper>
    </Filter>
  );
};

export default PartnerDealersListSelector;
